<template>
  <div id="about">
    <div class="header">
      <HamburgerWhite/>
      <img :src="this.strings.aboutImage" alt="about-image">
      <h2>{{ this.strings.aboutTitle }}</h2>
    </div>
    <div class="container">
      <div class="main-content">
        <div class="bread part" v-html="this.strings.aboutText"></div>
        <div id="line"></div>
      </div>
    <div class="side-nav">
        <div class="side-nav-container">
        <div class="disposition social">
          <h6>Dela & kommentera</h6>
          <div class="soc-med">
            <div class="linkedin" @click="shareLinkedIn()"></div>
            <div class="facebook" @click="shareFB()"></div>
            <!--<div class="google"></div>-->
            <div class="twitter" @click="shareTwitter()"></div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HamburgerWhite from '@/components/HamburgerWhite'

export default {
  name: 'About',
  data () {
    return {
      msg: 'Empty component'
    }
  },
  props: [],
  computed: {
    pages () {
      return this.$store.state.pages
    },
    strings () {
      let returner = {
        aboutTitle: '...',
        aboutText: '...',
        aboutImage: '...'
      }
      if (this.pages && typeof this.pages[2] !== 'undefined') {
        returner.aboutTitle = this.pages[2].title.rendered
        returner.aboutText = this.pages[2].content.rendered
        returner.aboutImage = this.pages[2].acf.image.url
      }
      return returner
    }
  },
  watch: {
    strings () {
    }
  },
  methods: {
    handleScroll () {
      var divs = document.querySelectorAll('.part')
      var partFour = divs[0].getBoundingClientRect().bottom
      var partLineOffset = document.getElementById('line').offsetTop
      var menu = document.querySelector('.side-nav-container')
      if (partFour < 200) {
        menu.style.position = 'absolute'
        menu.style.top = partLineOffset - 205 + 'px'
      } else if (window.pageYOffset >= 480) {
        menu.style.position = 'fixed'
        menu.style.top = '0px'
      } else {
        menu.style.position = 'static'
        menu.style.top = ''
      }
    },
    shareFB () {
      if (window.FB) {
        window.FB.ui({
          method: 'share',
          href: window.location.href
        }, (response) => { })
      }
    },
    shareLinkedIn (ev) {
      window.open('http://www.linkedin.com/shareArticle?mini=true&url=' + window.location.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=420,width=650')
    },
    shareTwitter (ev) {
      window.open('https://twitter.com/intent/tweet?url=' + window.location.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600')
      return false
    }
  },
  mounted () {
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  components: {HamburgerWhite}
}
</script>

<style lang="scss">
#about > div.main-content > div.bread > p {
  margin: 0px 0 0 20px;
  max-width: 620px;
}
@media #{$ipads} {
  #about .main-content .bread p {
    margin-left: 20px;
  }
}
@media #{$small-pads} {
  #about .main-content .bread p {
    text-align:left;
    margin: 20px;
    width: auto;
    max-width: auto;
    min-width: auto;
  }
}
</style>
<style lang="scss" scoped>
#about {
  img {
    width: 100%;
    height: 480px;
    object-fit: cover;
    object-position: center;
    position: relative;
  }
  h2 {
    position: absolute;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    top:25%;
  }
  .main-content {
    max-width: 620px;
  }
  .container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 50px;
  }
  .bread {
    text-align: left;
    margin-right:30px;
    margin-top:0;
  }
  #line {
    width: 100%;
    height: 2px;
    margin-top: 20px;
    margin-bottom: 10px;
    background: $lightGrey;
  }
  .side-nav {
    width: 228px;
  }
  .social {
    display: flex;
    flex-direction: column;
    align-items: center;
    border-left: 5px solid #800756;
    height: 100px;
    margin-left: 20px;
    h6 {
      max-width: 180px;
      text-align: left;
      margin-left:25px;
    }
  }
  .soc-med {
      margin-left: 15px;
      margin-top: 12px;
      width: 167px;
      display: flex;
      justify-content: flex-start;
      div {
        margin-right: 10px;
        transition: all 0.2s ease;
        &:hover {
          transform: scale(0.92);
        }
      }
    }
  .linkedin {
    background: url('../assets/img/rb_linkedin.svg');
    background-size: cover;
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
  .facebook {
    background: url('../assets/img/rb_facebook.svg');
    background-size: cover;
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
  .google {
    background: url('../assets/img/rb_google.svg');
    background-size: cover;
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
  .twitter {
    background: url('../assets/img/rb_twitter.svg');
    background-size: cover;
    width: 34px;
    height: 34px;
    cursor: pointer;
  }
}
@media #{$ipads} {
  #about .social h6 {
    min-width: 180px;
  }
}
@media #{$small-pads} {
  #about .main-content {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: auto;
  }
  #about .social, .side-nav {
    display: none;
  }
  #about .bread {
    margin: 40px 0 0 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue